import React, { useEffect, useState } from 'react';
const trackFbEvent = (event: string, data?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', event, data);
  }
};
type Plan = 'megapack' | 'megapack-pro';
export function Pricing() {
  useEffect(() => {
    const section = document.getElementById('pricing');
    if (!section) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        trackFbEvent('ViewContent', {
          content_name: 'Pricing Section',
          content_category: 'Megapack Artes Marciales'
        });
        observer.disconnect();
      }
    }, {
      threshold: 0.3
    });
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
  const [selected, setSelected] = useState<Plan>('megapack-pro');
  const cartUrls: Record<Plan, string> = {
    megapack: 'https://checkout.construyeprogreso.com/cart/48217959366826:1',
    'megapack-pro': 'https://checkout.construyeprogreso.com/cart/48217960120490:1'
  };
  const ctaLabels: Record<Plan, string> = {
    megapack: 'SÍ, QUIERO EL MEGAPACK ARTES MARCIALES',
    'megapack-pro': 'SÍ, QUIERO EL MEGAPACK + ACADEMIA ONLINE'
  };
  return <section id="pricing" className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: 'rgb(24, 10, 10)',
    backgroundImage: 'radial-gradient(ellipse at center top, rgba(196, 30, 58, 0.15) 0%, transparent 50%), radial-gradient(ellipse at center bottom, rgba(196, 30, 58, 0.12) 0%, transparent 50%), linear-gradient(180deg, rgb(30, 8, 12) 0%, rgb(18, 6, 8) 40%, rgb(30, 8, 12) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-167">
      <div className="mx-auto max-w-3xl" data-id="element-168">
        {/* TÍTULO */}
        <h2 className="font-black text-center text-white m-0 mb-2 text-[25px]" data-id="element-169">
          Elegí tu{' '}
          <span className="text-red-500" data-id="element-170">Megapack Artes Marciales:</span>
        </h2>
        <p className="text-center text-gray-500 m-0 mb-8 text-[12px]" data-id="element-171">
          Las dos opciones incluyen los 6 bonos de implementación completos
        </p>

        <div className="mb-6 mx-auto max-w-2xl" data-id="element-172">
          {/* OPCIÓN 1 — MEGAPACK BASE */}
          <button onClick={() => setSelected('megapack')} className={`w-full text-left transition-all rounded-xl p-4 cursor-pointer shadow-sm ${selected === 'megapack' ? 'border-2 border-red-500' : 'border border-gray-800'}`} style={{
          backgroundColor: 'rgb(20, 10, 10)'
        }} data-id="element-173">
            <div className="flex flex-row items-center gap-3" data-id="element-174">
              <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-175">
                <div className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${selected === 'megapack' ? 'border-red-500' : 'border-gray-600'}`} data-id="element-176">
                  {selected === 'megapack' && <div className="h-2.5 w-2.5 bg-red-500 rounded-full" data-id="element-177" />}
                </div>
                <div className="min-w-0 flex-1" data-id="element-178">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-179">
                    <span className="text-sm sm:text-base" data-id="element-180">🥋</span>
                    <span className="text-sm sm:text-base font-black text-white" data-id="element-181">
                      MEGAPACK ARTES MARCIALES
                    </span>
                  </div>
                  <p className="text-xs text-gray-500 mt-1 mb-0" data-id="element-182">
                    6 Tomos + 6 Bonos · +600 páginas · Sistema Maestro completo
                  </p>
                </div>
              </div>
              <div className="shrink-0 text-right" data-id="element-183">
                <div className="text-xs text-gray-600 line-through" data-id="element-184">
                  $49.990
                </div>
                <div className="text-xl sm:text-2xl font-black text-white" data-id="element-185">
                  $19.990
                </div>
              </div>
            </div>
          </button>

          {/* OPCIÓN 2 — MEGAPACK + ACADEMIA ONLINE */}
          <button onClick={() => setSelected('megapack-pro')} className={`w-full text-left transition-all rounded-xl p-4 mt-3 cursor-pointer shadow-sm ${selected === 'megapack-pro' ? 'border-2 border-red-500' : 'border border-gray-800'}`} style={{
          backgroundColor: 'rgb(30, 5, 5)',
          boxShadow: selected === 'megapack-pro' ? 'rgba(196, 30, 58, 0.2) 0px 0px 30px 0px' : 'none'
        }} data-id="element-186">
            <div className="flex gap-3 flex-row items-center justify-end" data-id="element-187">
              <div className="flex items-start gap-3 flex-1 min-w-0" data-id="element-188">
                <div className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 mt-0.5 ${selected === 'megapack-pro' ? 'border-red-500' : 'border-gray-600'}`} data-id="element-189">
                  {selected === 'megapack-pro' && <div className="h-2.5 w-2.5 bg-red-500 rounded-full" data-id="element-190" />}
                </div>
                <div className="min-w-0 flex-1" data-id="element-191">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-192">
                    <span className="text-sm sm:text-base" data-id="element-193">🏆</span>
                    <span className="text-sm sm:text-base font-black text-white" data-id="element-194">
                      MEGAPACK ARTES MARCIALES + ACADEMIA ONLINE™
                    </span>
                  </div>
                  <div className="mt-1.5 flex flex-wrap items-center gap-1.5" data-id="element-195">
                    <span className="bg-red-600 text-[10px] font-black text-white rounded-full px-2 py-0.5" data-id="element-196">
                      ⭐ MÁS ELEGIDO
                    </span>
                    <span className="bg-red-950 text-[10px] font-bold text-red-400 border border-red-800 rounded-full px-2 py-0.5" data-id="element-197">
                      AHORRÁS $36.900
                    </span>
                  </div>
                  <p className="text-xs text-gray-400 mt-1.5 mb-0" data-id="element-198">
                    Todo el Megapack + el sistema completo para digitalizar tu
                    escuela, grabar tus clases y vender suscripciones online a
                    todo el país.
                  </p>
                </div>
              </div>
              <div className="shrink-0 text-right" data-id="element-199">
                <div className="text-xs text-gray-600 line-through" data-id="element-200">
                  $64.990
                </div>
                <div className="text-xl sm:text-2xl font-black text-red-500" data-id="element-201">
                  $27.990
                </div>
              </div>
            </div>
          </button>
        </div>

        {/* CTA PRINCIPAL */}
        <div className="mx-auto max-w-2xl" data-id="element-202">
          <a href={cartUrls[selected]} onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: selected === 'megapack-pro' ? 'Megapack Artes Marciales + Academia Online™' : 'Megapack Artes Marciales',
          content_category: 'Artes Marciales',
          value: selected === 'megapack-pro' ? 27990 : 19990,
          currency: 'ARS'
        })} className="block w-full text-white text-center text-sm sm:text-lg font-black rounded-2xl py-5 no-underline will-change-transform shadow-xl transition-transform active:scale-95" style={{
          background: 'linear-gradient(135deg, rgb(153, 0, 0) 0%, rgb(196, 30, 58) 50%, rgb(220, 50, 80) 100%)',
          boxShadow: '0 8px 32px rgba(196, 30, 58, 0.5), 0 2px 8px rgba(0,0,0,0.3)',
          letterSpacing: '0.5px',
          animation: 'pricingPulse 2.5s ease-in-out infinite'
        }} data-id="element-203">
            🥋 {ctaLabels[selected]} →
          </a>

          <p className="text-center text-xs italic text-gray-500 mt-3 mb-0" data-id="element-204">
            La opción más elegida por instructores que quieren una escuela
            profesional, rentable y con alumnos que se quedan
          </p>

          {/* GARANTÍAS */}
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3 text-xs text-gray-500 rounded-lg px-4 py-3 shadow-sm" style={{
          backgroundColor: 'rgb(20, 5, 5)',
          border: '1px solid rgba(196, 30, 58, 0.2)'
        }} data-id="element-205">
            <span data-id="element-206">🔒 Pago seguro</span>
            <span data-id="element-207">⚡ Acceso en 5 min</span>
            <span data-id="element-208">🛡️ Garantía 7 días</span>
            <span data-id="element-209">💳 Mercado Pago</span>
            <span data-id="element-210">📄 PDF listo para implementar</span>
          </div>
        </div>
      </div>
    </section>;
}